import { render } from "./salesContents.vue?vue&type=template&id=7acfcf1a&scoped=true"
import script from "./salesContents.vue?vue&type=script&lang=js"
export * from "./salesContents.vue?vue&type=script&lang=js"

import "./salesContents.vue?vue&type=style&index=0&id=7acfcf1a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acfcf1a"]])

export default __exports__